<div class="sac-flow-wrapper" *ngIf="!isMobile">
  <div class="heading">
    <h2>{{title}}</h2>
  </div>
  <div class="content-container">
    <div class="left-section">
      <div class="cards" *ngFor="let item of steps">
        <div class="icon">
          <img [src]="item?.icon">
        </div>
        <div class="data">
          <span class="title">
            {{item?.title}}
          </span>
          <span class=desc>
            {{item?.desc}}
          </span>
        </div>
      </div>
    </div>
    <div class="right-section" inViewport (inViewportAction)="playVideo($event)">
      <img loading="lazy" data-src="{{vars.defaultBlurImg}}" width="270" height="550" [hidden]="!imgLoader" alt="Default image" />
      <video width="270" height="550" muted loop #videoPlayer playsinline>
        <source src="'/assets/videos/screen_recording.webm'+'#t=0.001'" type="video/webm">
        <source [src]="'/assets/videos/screen_recording.mp4'+'#t=0.001'" type="video/mp4">
        <p>Your browser doesn't support HTML5 video. Here is
          a <a href="https://d1vdjc70h9nzd9.cloudfront.net/videos/screen_recording.webm">link to the video</a> instead.
        </p>
      </video>
    </div>
  </div>
  <div class="call-to-action text-center">
    <app-startfundraiser-button label="Start a Fundraiser for FREE" pageName="home" info2="home_2" [width]="isMobile ? '100%' : '290px'" height="51px"></app-startfundraiser-button>
  </div>
</div>

<div class="sac-flow-wrapper-mobile" *ngIf="isMobile">
  <div class="heading">
    <h2>{{mobileTitle}}</h2>
  </div>
  <div class="content-container">
    <div class="mobile-wrapper">
      <div class="cards" *ngFor="let item of steps">
        <div class="icon">
          <img [src]="item?.icon">
        </div>
        <div class="data">
          <span class="title">
            {{item?.title}}
          </span>
          <span class=desc>
            {{item?.desc}}
          </span>
        </div>
      </div>
    </div>
    <div class="right-section" inViewport (inViewportAction)="playVideo($event)" *ngIf="showMWebMobile">
      <img loading="lazy" data-src="{{vars.defaultBlurImg}}" width="124" height="251" [hidden]="!imgLoader" alt="Default image" />
      <video width="124" height="251" muted loop #videoPlayer playsinline>
        <source src="'/assets/videos/screen_recording.webm'+'#t=0.001'" type="video/webm">
        <source [src]="'/assets/videos/screen_recording.mp4'+'#t=0.001'" type="video/mp4">
        <p>Your browser doesn't support HTML5 video. Here is
          a <a href="https://d1vdjc70h9nzd9.cloudfront.net/videos/screen_recording.webm">link to the video</a> instead.
        </p>
      </video>
    </div>
  </div>
  <div class="call-to-action text-center">
    <app-startfundraiser-button label="Start a Fundraiser for FREE" pageName="home" info2="home_2" [width]="isMobile ? '100%' : '290px'" height="51px"></app-startfundraiser-button>
  </div>
</div>
